import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { IconCoins } from '@/components/custom';
import { EyeOff, Rocket } from 'lucide-react';
import { MainTabEnum } from './mainTab.enum';
import { TFormData } from '.';

const TITLES_BY_TAB: Record<MainTabEnum, { icon: React.JSX.Element; label: string }> = {
  [MainTabEnum.COINS]: { icon: <IconCoins />, label: 'pièces' },
  [MainTabEnum.INCOGNITO]: { icon: <EyeOff size={18} className='text-slate-500' />, label: 'incognito' },
  [MainTabEnum.BOOST]: { icon: <Rocket size={18} className='text-orange-500' />, label: 'boost' },
};

const FormSetCoinsToUserHeader = () => {

  const { control } = useFormContext<TFormData>();
  const username = useWatch({ control, name: 'user.username' });
  const mainTab = useWatch({ control, name: 'mainTab' });

  const { icon, label } = TITLES_BY_TAB[mainTab] ?? TITLES_BY_TAB[MainTabEnum.COINS];

  return (
    <DialogHeader>
      <DialogTitle className='flex items-center gap-2'>
        {icon}
        Ajout de {label}
      </DialogTitle>
      <DialogDescription asChild>
        <div className='space-x-1'>
          <span>
            Vous êtes sur le point d'ajouter du {label} à
          </span>
          <span className='text-purple-600'>
            {username}.
          </span>
        </div>
      </DialogDescription>
    </DialogHeader>
  );

};

export default FormSetCoinsToUserHeader;
